import { useSSRData } from 'hooks';
import { getWishlist } from 'utils';
import getFirstCorrectData from './utils';

const useWishList = () => {
    const state = useSSRData();
    return getFirstCorrectData(state.wishlist, getWishlist(), {});
};

export default useWishList;
